export default __webpack_public_path__ + "static/media/ctr.48725b42.svg";